import baseInitState from 'src/helpers/redux/baseInitState'
import baseReducer from 'src/helpers/redux/baseReducer'

import { actionType } from './partner.action'

const initState = {
  ...baseInitState,
  isLoadingExport: false,
  configZakatFitrah: null,
}

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actionType('exportFile').request:
      return {
        ...state,
        isLoadingExport: true,
      }
    case actionType('exportFile').success:
      return {
        ...state,
        isLoadingExport: false,
      }
    case actionType('exportFile').error:
      return {
        ...state,
        isLoadingExport: false,
      }
    case actionType('getZakatFitrah').success:
      return {
        ...state,
        configZakatFitrah: action.payload.data,
      }

    default:
      return baseReducer(state, action, actionType)
  }
}
